import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TextInput } from '../../shared/components/text-input/text-input';
import { AuthSidePanel } from '../../shared/components/auth-side-panel/auth-side-panel';
import { Auth as AuthService } from '../../core/services/auth';
import { Toast } from '../../shared/services/toast';
import { Toast as ToastComponent } from '../../shared/components/toast/toast';
import { Button } from '../../shared/components/button/button';
@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [CommonModule, FormsModule, TextInput, AuthSidePanel, ToastComponent, Button],
  templateUrl: './auth.html',
  styleUrl: './auth.css'
})
export class Auth {
  private authService = inject(AuthService);
  private toast = inject(Toast);
  private router = inject(Router);

  loginEmail: string = '';
  loginPassword: string = '';

  emailError: string = '';
  passwordError: string = '';

  isLoading = signal(false);

  private isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  onLogin() {
    this.emailError = '';
    this.passwordError = '';

    let hasError = false;

    if (!this.loginEmail.trim()) {
      this.emailError = 'Email is required.';
      hasError = true;
    } else if (!this.isValidEmail(this.loginEmail)) {
      this.emailError = 'Enter a valid email address.';
      hasError = true;
    }

    if (!this.loginPassword.trim()) {
      this.passwordError = 'Password is required.';
      hasError = true;
    }

    if (hasError) return;

    this.isLoading.set(true);

    this.authService.login({ email: this.loginEmail, password: this.loginPassword }).subscribe({
      next: () => {
        this.isLoading.set(false);
        this.toast.show('Logged in successfully.', 'success');
        this.router.navigate(['/dashboard']);
      },
      error: (err) => {
        this.isLoading.set(false);
        const message = err?.error?.message || 'An error occurred. Please try again.';
        this.toast.show(message, 'error');
      }
    });
  }
}